import {FilesList} from './components/FilesList';

export default FilesList;
